import { Directive, HostBinding, Input, OnChanges } from '@angular/core';
import {
  EnhancedRating,
  extractUniqueRatings,
  extractUniqueUnderlyingRatings,
  isEachNotRated
} from '../../../helpers/issue/ratings';
import { BasicSeries, Rating } from '../../../types/deal.types';

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class BaseAgencyRatingComponent implements OnChanges {
  @HostBinding('style.height')
  public get getHeight(): string {
    return this.height + 'px';
  }

  @Input()
  public height = 18;

  @Input()
  public agencyName: string;

  @Input()
  public automationPrefix: string;

  public ratings: EnhancedRating[] = [];
  public underlyingRatings: Rating[] = [];
  public allEnhanced = false;

  ngOnChanges() {
    this.ratings = extractUniqueRatings(this.seriesList, this.agencyName);
    this.underlyingRatings = extractUniqueUnderlyingRatings(
      this.seriesList,
      this.agencyName
    );
    this.allEnhanced = this.isEachEnhanced(this.ratings);
  }

  public automationSelector(prefix: string): string {
    return `${this.automationPrefix}-${prefix}-${this.automationName}`;
  }

  protected abstract get seriesList(): BasicSeries[];
  protected abstract get automationName(): string;

  protected reduceValues(ratings: Rating[]): string {
    const validRatings = ratings.filter((r) => r !== null);
    if (isEachNotRated(validRatings)) {
      return null;
    }

    if (ratings.length > 1) {
      const allValues = ratings.map((rating) => {
        if (!rating) {
          return null;
        }

        const value = rating.rating || rating.shortTerm;
        return value ? value.trim() : value;
      });

      const uniqueValues = new Set(allValues);

      if (uniqueValues.size === 1) {
        return allValues[0];
      }

      return 'Var';
    }

    return validRatings[0]?.rating || validRatings[0]?.shortTerm;
  }

  protected isEachEnhanced(ratings: EnhancedRating[]) {
    const nonNullRatings = ratings.filter((rating) => rating !== null);
    return (
      nonNullRatings.length &&
      nonNullRatings.every((rating) => !!rating.enhancement)
    );
  }
}
